module.exports = "<p>leave-type works!</p>\n"